<script lang="js">
import axios from 'axios';

export default {
  data() {
    return {
      logger: null,
      staffNumber: "",
      password: "",
      rememberMe: false,
      showPassword: false,
      loading: false,
      errorMessage: "",
    };
  },
  created() {
    // Create a logger instance for this component
    this.logger = this.$createLogger('StaffLoginView');
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async login() {
      try {
        this.loading = true;
        this.errorMessage = "";

        // Call the backend API to authenticate staff
        const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/auth/login`, {
          identifier: this.staffNumber,
          password: this.password,
          rememberMe: this.rememberMe, // Send remember me flag
        }, {
          withCredentials: true, // Include cookies
        });

        if (response.data.success) {
          if (response.data.data.context?.user?.role !== "staff") {
            await axios.post(
              `${process.env.VUE_APP_API_BASE_URL}/auth/logout`,
              {},
              { withCredentials: true }
            );
            throw new Error(
              "Applicant and student accounts must sign in through the student portal"
            );
          }
          // Store staff data in Vuex store
          this.$store.commit("setSession", response.data.data.context);

          // Store access token in Vuex and set it in axios headers
          if (response.data.data.accessToken) {
            this.$store.commit("setAccessToken", response.data.data.accessToken);
          }

          // Mark auth as checked so router guard doesn't re-verify
          this.$store.commit("setAuthChecked", true);

          // Redirect to staff dashboard
          this.$router.push({ name: 'staffDashboard' });
        } else {
          this.errorMessage = response.data.message || "Login failed. Please check your credentials.";
        }
      } catch (error) {
        this.logger.error('Login error:', error);
        this.errorMessage = error.response?.data?.message || error.message || "An error occurred during login. Please try again.";
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
<template>
  <div class="container-fluid bg-body-tertiary">
    <div class="d-flex align-items-center py-4 vh-100">
      <main class="form-signin w-100 m-auto">
        <form @submit.prevent="login">
          <!-- <RouterLink to="/staff"> -->
          <img
            src="@/assets/logo.png"
            class="mb-4"
            alt=""
            width="96.26"
            height="70"
          />
          <!-- </RouterLink> -->
          <h1 class="h3 mb-3 fw-bold text-uppercase">FCP Staff Login</h1>
          <p>Please fill out the following fields to login</p>

          <div
            v-if="errorMessage"
            class="alert alert-danger alert-dismissible fade show mt-3 d-flex justify-content-between"
            role="alert"
          >
            <div>
              <i class="bi bi-exclamation-triangle-fill me-2"></i>
              {{ errorMessage }}
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>

          <div class="form-floating">
            <input
              type="text"
              class="form-control border border-bottom-0 rounded-bottom-0"
              v-model="staffNumber"
              id="floatingInput"
              placeholder="FCP/ACD/001"
              required
            />
            <label for="floatingInput">Staff Number</label>
          </div>
          <div class="input-group">
            <div class="form-floating">
              <input
                :type="showPassword ? 'text' : 'password'"
                class="form-control mb-0"
                id="floatingPassword"
                v-model="password"
                placeholder="Password"
                required
              />
              <label for="floatingPassword">Password</label>
            </div>

            <i
              :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"
              class="text-muted input-group-text bg-white border-start-0 rounded-top-0"
              id="pwd-addon"
              @click="togglePassword"
            ></i>
          </div>

          <div class="form-check text-start my-3">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="rememberMe"
              id="flexCheckDefault"
            />
            <label class="form-check-label" for="flexCheckDefault">
              Remember me
            </label>
          </div>

          <div class="d-grid gap-2 col-6 mx-auto mb-5">
            <button class="btn btn-success" type="submit" :disabled="loading">
              {{ loading ? "Signing In..." : "Sign In" }}
            </button>
          </div>

          <hr />

          <p class="mt-3 mb-3 text-body-secondary">
            © 2022–{{ new Date().getFullYear() }}
          </p>
        </form>
      </main>
    </div>
  </div>
</template>
<style scoped>
html,
body {
  height: 100%;
}

.form-signin {
  max-width: 530px;
  padding: 1rem;
}

.form-signin .form-floating:focus-within {
  z-index: 2;
}

.form-signin input[type="text"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
